import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
type CTAButtonProps = {
  label: string;
  sublabel?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  sublabel,
  id,
  className = ""
}: CTAButtonProps) {
  return <div id={id} className={`w-full max-w-xl mx-auto ${className}`} data-id="element-18" data-mp="2fz214mhtqwvi">
      <a href={CHECKOUT_URL} className="group flex w-full items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-center text-white shadow-[0_10px_0_0_#0d6b30,0_18px_30px_-10px_rgba(22,163,74,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-ctadark active:translate-y-[6px] active:shadow-[0_4px_0_0_#0d6b30] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40" data-id="element-19" data-mp="2g1xz2ato9ljy">
        <span className="text-[17px] sm:text-xl font-extrabold uppercase leading-tight tracking-wide" data-id="element-20" data-mp="3cqni44h1ck7i">
          {label}
        </span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden data-id="element-21" data-mp="38m61uf9vwp1h" />
      </a>
      {sublabel && <p className="mt-4 text-center text-[13px] sm:text-sm text-muted leading-relaxed" data-id="element-22" data-mp="1db9nnq11t1xo">{sublabel}</p>}
    </div>;
}